export default {
  label: "Feedback",
  placeholder: {
    label: "John Doe",
    initials: "JD",
  },
};
